// utils/subtitleEncoding.js

/**
 * 🆕 حذف کاراکترهای کنترلی یونیکد
 * این کاراکترها می‌تونن باعث عدم تطابق بین پارسر JSON و VTT بشن
 */
const removeUnicodeControlChars = (text) => {
  return text.replace(
    /[\u202A\u202B\u202C\u202D\u202E\u2066\u2067\u2068\u2069\u200E\u200F\uFEFF]/g,
    "",
  );
};

/**
 * تشخیص و تبدیل کدگذاری‌های مختلف فارسی به UTF-8
 * @param {File} file - فایل زیرنویس
 * @returns {Promise<string>} - متن با کدگذاری صحیح
 */
export const readFileWithProperEncoding = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = () => {
      let text = "";
      try {
        // اول تلاش می‌کنیم با UTF-8 بخونیم
        const decoder = new TextDecoder("utf-8", { fatal: true });
        text = decoder.decode(new Uint8Array(reader.result));
      } catch (e) {
        // اگر UTF-8 نشد، کدگذاری‌های فارسی رو امتحان می‌کنیم
        const encodings = ["windows-1256", "iso-8859-6"];

        for (const encoding of encodings) {
          try {
            const decoder = new TextDecoder(encoding);
            const testText = decoder.decode(new Uint8Array(reader.result));

            // چک می‌کنیم آیا کاراکترهای فارسی داره یا نه
            if (/[\u0600-\u06FF]/.test(testText)) {
              text = testText;
              break;
            }
          } catch (err) {
            continue;
          }
        }

        // اگه هیچکدوم جواب نداد، با UTF-8 برگردون
        if (!text) {
          const decoder = new TextDecoder("utf-8");
          text = decoder.decode(new Uint8Array(reader.result));
        }
      }

      // حذف BOM
      text = text.replace(/^\uFEFF/, "");

      // 🆕 حذف کاراکترهای کنترلی
      text = removeUnicodeControlChars(text);

      resolve(text);
    };

    reader.onerror = reject;
    reader.readAsArrayBuffer(file);
  });
};

/**
 * تبدیل SRT به WebVTT
 * @param {string} srtText - متن SRT
 * @returns {string} - متن WebVTT
 */
export const srtToWebVTT = (srtText) => {
  // 🆕 حذف کاراکترهای کنترلی
  srtText = removeUnicodeControlChars(srtText);

  srtText = srtText.replace(/^\uFEFF/, "");

  let vttText = "WEBVTT\n\n";
  const subtitles = srtText.split(/\r?\n\r?\n/);

  subtitles.forEach((sub, index) => {
    if (!sub.trim()) return;
    const lines = sub.split(/\r?\n/);
    if (lines.length < 2) return;

    vttText += `${index + 1}\n`;
    const timeLine = lines[1].replace(/,/g, ".");
    vttText += timeLine + "\n";

    for (let i = 2; i < lines.length; i++) {
      if (lines[i].trim()) {
        vttText += lines[i] + "\n";
      }
    }
    vttText += "\n";
  });

  return vttText;
};

/**
 * تبدیل فایل SRT به JSON با تشخیص خودکار کدگذاری
 * @param {File} file - فایل زیرنویس
 * @returns {Promise<Array>} - آرایه از cues
 */
export const parseSRTFileWithEncoding = async (file) => {
  try {
    // ایمپورت داینامیک srt-parser-2
    const srtParser2 = (await import("srt-parser-2")).default;
    const text = await readFileWithProperEncoding(file);

    // 🆕 حذف کاراکترهای کنترلی (readFileWithProperEncoding قبلاً این کار رو کرده،
    // ولی برای اطمینان دوباره انجام می‌دیم)
    const cleanedText = removeUnicodeControlChars(text);

    const parser = new srtParser2();
    return parser.fromSrt(cleanedText);
  } catch (error) {
    throw error;
  }
};
